import React from 'react';
import { Typography } from '@material-ui/core';
import HealtheraTable from '../../../../../../components/Table/Table';
import TableContainer from '../../../../../Shared/TableContainer';
import { User } from '../../../../../../apis/users';

interface PrescribersTableProps {
  prescribers: User[];
  isLoading: boolean;
  onRowClick: (rowData: any) => void;
  onDeleteClick: (user: User) => void;
}

const PrescribersTable: React.FC<PrescribersTableProps> = ({
  prescribers,
  isLoading,
  onRowClick,
  onDeleteClick
}) => {
  const preparePrescriberData = (users: User[]) => {
    return [
      {
        view: {
          name: { title: 'Name', width: '20%' },
          email: { title: 'Email', width: '32%' },
          roles: { title: 'Roles', width: '20%' },
          clinicPages: { title: 'Clinic pages', width: '13%' }
        },
        headers: true
      },
      ...users.map(user => ({
        ID: user._id,
        view: {
          name: `${user.forename} ${user.surname}`,
          email: user.username || '-',
          roles: user.roles?.join(', ') || '-',
          clinicPages: user.show_on_clinic ? 'Shown' : '-'
        },
        button: {
          title: 'Remove',
          onClick: (e: React.MouseEvent) => {
            e.stopPropagation();
            onDeleteClick(user);
          }
        }
      }))
    ];
  };

  return (
    <TableContainer>
      {isLoading ? (
        <Typography>Loading...</Typography>
      ) : (
        <HealtheraTable
          data={preparePrescriberData(prescribers)}
          displayPagination={false}
          isLiveDashboard={false}
          noHover={false}
          totalCount={prescribers.length}
          page={0}
          rowsPerPage={10}
          rowsPerPageOptions={[10]}
          onChangePage={() => {}}
          onRowsPerPageChange={() => {}}
          onRowClick={onRowClick}
        />
      )}
    </TableContainer>
  );
};

export default PrescribersTable; 